module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/logo2.1c885405.png";